/**
 * Assets Hub API Setup
 * Uses shared @quotech/api bootstrap — see packages/api/src/setupHubApi.ts
 */
export { getConfiguredClient } from '@quotech/api'
import { setupHubApi, getDefaultClient } from '@quotech/api'

/** Call once in main.tsx before rendering. */
export function initializeApi() {
  setupHubApi({ hubName: 'Assets' })
}

// Export with expected name for main.tsx
export const setupAssetsApi = initializeApi

// Re-export configured client for backward compat
export const apiClient = getDefaultClient()

/**
 * Assets-specific API endpoints
 */
export const assetsApi = {
  // Assets
  getAssets: (params?: Record<string, unknown>) => getDefaultClient().get('/api/assets/', { params }),
  getAsset: (id: string) => getDefaultClient().get(`/api/assets/${id}/`),
  createAsset: (data: unknown) => getDefaultClient().post('/api/assets/', data),
  updateAsset: (id: string, data: unknown) => getDefaultClient().put(`/api/assets/${id}/`, data),

  // Maintenance
  getMaintenanceRecords: (assetId?: string) => getDefaultClient().get('/api/assets/maintenance/', { params: { asset: assetId } }),
  createMaintenanceRecord: (data: unknown) => getDefaultClient().post('/api/assets/maintenance/', data),

  // Tracking
  getAssetLocation: (assetId: string) => getDefaultClient().get(`/api/assets/${assetId}/location/`),
  getLocationHistory: (assetId: string) => getDefaultClient().get(`/api/assets/${assetId}/location/history/`),

  // Bookings
  getBookings: () => getDefaultClient().get('/api/assets/bookings/'),
  createBooking: (data: unknown) => getDefaultClient().post('/api/assets/bookings/', data),

  // Reports
  getUtilizationReport: () => getDefaultClient().get('/api/assets/reports/utilization/'),
  getCostReport: () => getDefaultClient().get('/api/assets/reports/costs/'),

  // Alerts
  getMaintenanceAlerts: () => getDefaultClient().get('/api/assets/alerts/maintenance/'),
}
